import React from 'react';
import {Trans} from '@lingui/macro';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const CustomExchangeRateInfo = {
    title: () => (
        <>
            <ExclamationCircleOutlined
                style={{ color: '#faad14', marginRight: 8, fontSize: 22, position: 'relative', top: 3 }}
            />
        &nbsp;&nbsp;
            <Trans>Warning</Trans>
        </>
    ),
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.custom_exchange_rate_updated_feedback = true;
        handleOk(newAction);
    },
    bodyStyle: {},
    noPasscode: true,
};

function CustomExchangeRate() {
    return (
        <span>
            <p>
                <Trans>
                    This action will replace the exchange rate in all existing transactions involving this currency with the new custom rate.
                </Trans>
            </p>
            <p>
                <Trans>Do you want to proceed?</Trans>
            </p>
        </span>
    );
}

export default CustomExchangeRate;
